//STYLES
import { Overlay } from "./styled";

//COMPONENTS
import ProgressLoading from "../progressLoading";
import { Render } from "../render";
import ButtonCustom from "../../ButtonCustom";

//PROPS
interface Props {
    open: boolean;
    pagina_atual: number;
    total_paginas: number;
    cancelando: boolean;
    onCancelar: () => void;
    titulo?: string;
}

export const LoadingPdf: React.FC<Props> = ({ open, pagina_atual, total_paginas, cancelando, onCancelar, titulo }) => {

    if (!open) {
        return null;
    }

    //enquanto as páginas ainda estão sendo contadas não há progresso para exibir
    const preparando = total_paginas === 0;

    const progresso = preparando
        ? 0
        : Math.min(100, Math.round((pagina_atual / total_paginas) * 100));

    const legenda = cancelando
        ? 'Cancelando...'
        : (preparando ? 'Preparando páginas...' : 'Gerando PDF...');

    return (
        <Overlay>
            <div className="Overlay__card">

                <h2 className="Overlay__card__titulo">
                    {titulo ?? 'Gerando PDF do book'}
                </h2>

                <ProgressLoading
                    animation
                    justifyContent="center"
                    legenda={legenda}
                    progress={progresso}
                    ocultar_tempo_restante={preparando || cancelando}
                />

                <Render condition={!preparando && !cancelando}>
                    <span className="Overlay__card__paginas">
                        Página {pagina_atual} de {total_paginas}
                    </span>
                </Render>

                <span className="Overlay__card__aviso">
                    {cancelando
                        ? 'Finalizando a página atual...'
                        : 'Mantenha esta aba aberta até a conclusão.'}
                </span>

                <div className="Overlay__card__acoes">
                    <ButtonCustom
                        onClick={onCancelar}
                        type="tertiary"
                        danger
                        disabled={cancelando}
                    >
                        {cancelando ? 'Cancelando...' : 'Cancelar'}
                    </ButtonCustom>
                </div>

            </div>
        </Overlay>
    )
}
